import { useState, useEffect } from 'react';

const ReadingProgressBar = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const update = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      setProgress(Math.min(100, Math.max(0, pct)));
    };

    window.addEventListener('scroll', update, { passive: true });
    update();
    return () => window.removeEventListener('scroll', update);
  }, []);

  return (
    <>
      {/* Background track */}
      <div className="fixed top-0 left-0 right-0 z-[60] h-[3px] bg-slate-100">
        {/* Fill */}
        <div
          className="h-full bg-gradient-to-r from-violet-500 via-violet-600 to-indigo-500 transition-[width] duration-75"
          style={{ width: `${progress}%` }}
        />
      </div>

      {/* Percentage badge – appears after 5% */}
      {progress > 5 && (
        <div
          className="fixed z-[60] top-4 right-4 bg-white border border-slate-200 text-violet-700 text-[11px] font-bold px-2.5 py-1 rounded-full shadow-sm select-none"
          style={{ opacity: progress > 5 ? 1 : 0, transition: 'opacity 0.3s' }}
        >
          {Math.round(progress)}%
        </div>
      )}
    </>
  );
};

export default ReadingProgressBar;
